
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/authenticator",
      function () {
        return require("private-next-pages/sign/authenticator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/authenticator"])
      });
    }
  